import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "w-75",
    attrs: {
      "title": "Informações da venda",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 3;
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Término da recorrência")]), _c('b-form-group', {
    attrs: {
      "label-for": "tempo_contrato"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "tempo_contrato",
      "options": _vm.tempo_contrato
    },
    model: {
      value: _vm.form.termino_recorrencia,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "termino_recorrencia", $$v);
      },
      expression: "form.termino_recorrencia"
    }
  })], 1)], 1), _vm.isPeriodoEspecifico ? _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "data_inicio"
    }
  }, [_vm._v("Início da vigência")]), _c('b-form-group', [_c('b-form-datepicker', {
    attrs: {
      "id": "data_inicio",
      "locale": "pt-br"
    },
    model: {
      value: _vm.form.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_inicio", $$v);
      },
      expression: "form.data_inicio"
    }
  })], 1)], 1) : _vm._e(), _vm.isPeriodoEspecifico ? _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "data_termino"
    }
  }, [_vm._v("Término da vigência")]), _c('b-form-group', [_c('b-form-datepicker', {
    attrs: {
      "id": "data_termino",
      "locale": "pt-br",
      "min": _vm.form.data_inicio || undefined
    },
    model: {
      value: _vm.form.data_termino,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_termino", $$v);
      },
      expression: "form.data_termino"
    }
  })], 1)], 1) : _vm._e(), _vm.isPeriodoEspecifico ? _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('label', [_vm._v("Vigência total")]), _c('b-form-group', [_c('b-badge', {
    attrs: {
      "variant": "primary",
      "pill": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.vigenciaTotal) + " meses ")])], 1)], 1) : _vm._e()], 1), _c('hr'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('label', [_vm._v("E-mail para receber fatura: ")]), _c('b-form-group', {
    attrs: {
      "id": "data_termino",
      "label-for": "E-mail para receber fatura: "
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email_fatura",
      "type": "email"
    },
    model: {
      value: _vm.form.email_fatura,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email_fatura", $$v);
      },
      expression: "form.email_fatura"
    }
  })], 1)], 1)], 1), !_vm.store.formFaturamento.cobranca_anual ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Emitir NFSe")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.emitir_nfse,
      expression: "form.emitir_nfse"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.emitir_nfse) ? _vm._i(_vm.form.emitir_nfse, null) > -1 : _vm.form.emitir_nfse
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.emitir_nfse,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "emitir_nfse", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "emitir_nfse", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "emitir_nfse", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Emitir Boletos")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.emitir_boletos,
      expression: "form.emitir_boletos"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.canGenerateBoleto
    },
    domProps: {
      "checked": Array.isArray(_vm.form.emitir_boletos) ? _vm._i(_vm.form.emitir_boletos, null) > -1 : _vm.form.emitir_boletos
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.emitir_boletos,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "emitir_boletos", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "emitir_boletos", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "emitir_boletos", $$c);
        }
      }
    }
  }), _c('span')])]), !_vm.canGenerateBoleto ? _c('small', {
    staticClass: "text-muted d-block mt-1"
  }, [_vm._v(" Configure uma integração de boleto nas contas bancárias para gerar boletos. ")]) : _vm._e()])], 1) : _vm._e(), _c('br'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.allStatus
    },
    on: {
      "input": _vm.setStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vendedor",
      "label-for": "vendedor"
    }
  }, [_c('VueSelect', {
    ref: "buscaVendedor",
    attrs: {
      "filterable": false,
      "options": _vm.vendedores
    },
    on: {
      "input": _vm.setVendedor,
      "open": _vm.onSearchVendedor,
      "search": _vm.onSearchVendedor
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.vendedor,
      callback: function callback($$v) {
        _vm.vendedor = $$v;
      },
      expression: "vendedor"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do vendedor ")])], 2)], 1)], 1)], 1), !_vm.store.formFaturamento.cobranca_anual ? _c('b-row', [_c('b-col', [_vm.isAtivoSelecionado ? _c('b-alert', {
    staticClass: "mt-2 d-flex align-items-start",
    attrs: {
      "variant": "primary",
      "show": ""
    }
  }, [_c('div', {
    staticClass: "mr-2"
  }, [_c('i', {
    staticClass: "la la-info-circle",
    staticStyle: {
      "font-size": "1.25rem"
    }
  })]), _c('div', [_c('div', {
    staticClass: "font-weight-bold mb-1"
  }, [_vm._v(" Ao ativar o contrato, o sistema irá iniciar as automações de faturamento: ")]), _c('ul', {
    staticClass: "mb-1 pl-3"
  }, [_vm.form.emitir_nfse ? _c('li', [_c('i', {
    staticClass: "la la-file-invoice mr-1"
  }), _vm._v(" Emitir "), _c('strong', [_vm._v("NFSe")]), _vm._v(" conforme os serviços configurados. ")]) : _vm._e(), _vm.form.emitir_boletos ? _c('li', [_c('i', {
    staticClass: "la la-barcode mr-1"
  }), _vm._v(" Gerar "), _c('strong', [_vm._v("boletos")]), _vm._v(" com vencimento no dia "), _c('strong', [_vm._v(_vm._s(_vm.store.formFaturamento.dia_cobranca || "—"))]), _vm._v(" do mês. ")]) : _vm._e(), _vm.currentEmpresaId !== 1 && (_vm.form.emitir_nfse || _vm.form.emitir_boletos) ? _c('li', [_c('i', {
    staticClass: "la la-envelope mr-1"
  }), _vm._v(" Processar faturamento e envio no dia "), _c('strong', [_vm._v(_vm._s(_vm.store.formFaturamento.dia_envio_fatura || 1))]), _vm._v(" do mês. ")]) : _vm._e(), !_vm.form.emitir_nfse && !_vm.form.emitir_boletos ? _c('li', {
    staticClass: "text-muted"
  }, [_vm._v(" Nenhuma automação marcada. Ative “Emitir NFSe” e/ou “Emitir Boletos” acima. ")]) : _vm._e()]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Você pode alterar essas opções antes de salvar: "), _c('em', [_vm._v("Emitir NFSe")]), _vm._v(", "), _c('em', [_vm._v("Emitir Boletos")]), _vm._v(" e "), _c('em', [_vm._v("Dia da Cobrança")]), _vm.currentEmpresaId !== 1 ? _c('span', [_vm._v(" e "), _c('em', [_vm._v("Dia de Envio")])]) : _vm._e(), _vm._v(". ")])])]) : _vm._e()], 1)], 1) : _vm._e(), _c('hr'), _c('b-row', [_c('b-col', {}, [_c('b-form-group', {
    attrs: {
      "label": "Informações Adicionais",
      "label-for": "observacao"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "no-resize": "",
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };